export default {
  'workprcs.type.1': {
    ko: 'DIA',
    en: 'DIA',
  },
};
